import React, { useState } from 'react'
import { useAppDispatch } from 'reduxTyped'
import { BtnV2, l } from '@manychat/manyui'

import { KnowledgeEntryDeleteModal } from 'apps/aiAutomation/components/KnowledgeEntryDeleteModal'
import { AiAutomationLayoutActions } from 'apps/aiAutomation/store/layout'
import {
  KnowledgeEntry,
  KnowledgeEntryState,
} from 'shared/api/requests/aiBusinessKnowledge/schemas'

interface EntryControlsProps {
  entry: KnowledgeEntry | null
  onSave: () => void
  isLoading: boolean
}

export const EntryControls = ({ entry, onSave, isLoading }: EntryControlsProps) => {
  const dispatch = useAppDispatch()

  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false)

  const showDeleteButton = entry && entry.state !== KnowledgeEntryState.IN_PROCESS
  const showSaveButton = !entry || entry.state === KnowledgeEntryState.PROCESSED

  return (
    <div className="m-t-lg d-flex justify-between">
      {isDeleteModalVisible && entry && (
        <KnowledgeEntryDeleteModal id={entry.id} onClose={() => setIsDeleteModalVisible(false)} />
      )}

      <div className="d-flex gap-sm">
        <BtnV2 onClick={() => dispatch(AiAutomationLayoutActions.sidebarClosed())}>
          {l.translate('Leave')}
        </BtnV2>

        {showDeleteButton && (
          <BtnV2
            leftIcon="DeleteForever"
            variant="danger-light"
            data-test-id="ai-automation/knowledge-item-delete-button"
            onClick={() => setIsDeleteModalVisible(true)}
          >
            {l.translate('Delete')}
          </BtnV2>
        )}
      </div>

      {showSaveButton && (
        <BtnV2
          label={l.translate('Save')}
          ariaLabel={l.translate('Save')}
          variant="primary"
          onClick={onSave}
          loading={isLoading}
          data-test-id="ai-automation/knowledge-editor-save-button"
        />
      )}
    </div>
  )
}
